import { RouteType } from "types/RouteType";
import AIAgentStore from "./AIAgentStore";
// import { ServiceStoreType } from "types/ServiceStoreTypes";

/**
 * Defines the route configuration for the AI Agent view.
 * This route configuration includes details such as the path, layout,
 * associated React components, and store interactions.
 */
const aiAgentRoute: RouteType[] = [
  {
    /**
     * The user-friendly name of the route, displayed in navigation elements.
     */
    name: "AI Agent",
    /**
     * The path associated with this route. Navigating to '/ai-agent' will render this view.
     */
    path: "/ai-agent",
    /**
     * The layout to use for this route. Specifies the base layout component under '/app'.
     */
    layout: "/app",

    /** 
     * The default query parameters for this route.
     */
    defaultQueryParams: {
      scheduleMode: false,
    },
    /**
     * Configuration for the viewport card, which defines the header and body content.
     */
    viewportCard: {
      /**
       * Configuration for the header section of the viewport card.
       */
      header: {
        /**
         * The title displayed in the header.
         */
        title: "AI Agent",
        /**
         * A React component to render in the header. Dynamically imported.
         */
        component: () => import("./AIAgent.Header"),
        /**
         * Enables a refresh button in the header, likely to refresh the data.
         */
        enableRefreshButton: true,
        /**
         * Enables a back button in the header, allowing navigation to the previous view.
         */
        enableBackButton: true,
      },
      /**
       * Configuration for the body section of the viewport card.
       */
      body: {
        /**
         * The React component to render in the body. Dynamically imported.
         */
        component: () => import("./AIAgent.Body"),
        grayBackground: true,
      },
    },
    group: 'Administration',
    /**
     * Indicates whether the route requires specific permissions. Set to false for this route.
     */
    requiresPermission: false,
    /**
     * Indicates whether the route requires authentication. Set to false for this route.
     */
    requiresAuth: false,
    /**
     * An array of channels associated with this route, likely used for real-time updates or notifications.
     */
    channels: ["chat"],
    /**
     * Defines dialogs associated with this route.
     */
    dialogs: [
      {
        /**
         * The name of the dialog.
         */
        name: "AI Agent Settings",
        /**
         * The title displayed in the dialog.
         */
        title: "AI Agent Settings",
        /**
         * A React component to render in the dialog. Dynamically imported.
         */
        component: () => import("./AIAgentDialogs/AIAgent.Settings.Dialog"),
      },
    ],
    /**
     * Enables automatic finding of data when the route is entered.
     */
    enableAutoFind: false,
    /**
     * A callback function triggered when the route is entered.
     * Used to fetch data or perform other initialization tasks.
     * @param {object} params - An object containing parameters, including the rootStore.
     * @param {object} params.rootStore - The root MobX store.
     */
    onEnter: async ({ rootStore }) => {
      // Load chat message history when entering the AI Agent view
      // Note: AIAgentStore is loaded via viewStores, no need to manually load here
    },
  },
];

export default aiAgentRoute;
